import { Col, Icon, Radio, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '@/src/shared/components/Button';
import Form from '@/src/shared/components/Form';
import Heading from '@/src/shared/components/Heading';
import X from '@/src/shared/components/Icon/_icons/X';
import Sanitize from '@/src/shared/components/Sanitize';
import { space } from '@/styles';
import { colMdProps, rowProps } from '@/utils/rowColHelpers';
import { multiSelectProps } from '@/utils/selectHelpers';

import style from '../style';

const { Option } = Select;
const { m } = space;
const ddErrorMsg =
  'You have selected to receive a custom version of the Daily Digest and have not chosen any jurisdictions or lines of business. Please select at least one jurisdiction or line of business, then click Save.';

const DailyDigest = ({ designData, form, options, profile }) => {
  const { Jurisdictions, DigestFormats, DigestScopes, LinesOfBusiness } = options;
  const { block, blockComponents } = designData;

  const clearJurisdictions = () => {
    form.setFieldsValue({
      Jurisdictions: [],
    });
  };

  const clearBusinesses = () => {
    form.setFieldsValue({
      LinesOfBusiness: [],
    });
  };

  const handleDigestScope = e => {
    const {
      target: { value },
    } = e;

    if (value === 1 || value === 3) {
      form.setFieldsValue({
        Jurisdictions: [],
        LinesOfBusiness: [],
      });
    }
  };

  const validateCustomDigest = (rule, value, callback) => {
    const lobValue = form.getFieldValue('LinesOfBusiness');
    const isLob = Boolean(Array.isArray(lobValue) && lobValue.length);

    const jurisdictionValue = form.getFieldValue('Jurisdictions');
    const isJurisdiction = Boolean(Array.isArray(jurisdictionValue) && jurisdictionValue.length);

    // If the user selected Custom Digest but there are no Lines of Business or Jurisdictions selected show the error message.
    if (value === 2 && (!isLob && !isJurisdiction)) {
      callback(ddErrorMsg);
    } else {
      callback();
    }
  };

  const jurisdictionChange = e => {
    const selectedJurisdictions = [...e];
    if (Array.isArray(selectedJurisdictions) && selectedJurisdictions.length) {
      form.setFieldsValue({ DigestScopeId: 2 });
    }
  };

  const lobChange = e => {
    const selectedLobs = [...e];
    if (Array.isArray(selectedLobs) && selectedLobs.length) {
      form.setFieldsValue({ DigestScopeId: 2 });
    }
  };

  return (
    <div css={style.rowWidth}>
      <Heading type={2} theme="primaryGray" size="md" weight="bold">
        {block.BlockTitle}
      </Heading>
      <div>
        {blockComponents.map(c => (
          <div css={style.description} key={c.BlockId}>
            <Sanitize>{c.Paragraph}</Sanitize>
          </div>
        ))}
      </div>
      <Row {...rowProps} css={m.t16}>
        <Col>
          <Form.Item css={style.formItemInline}>
            {form.getFieldDecorator('DigestScopeId', {
              initialValue: profile.DigestScopeId,
              rules: [
                {
                  validator: validateCustomDigest,
                },
              ],
            })(
              <Radio.Group css={style.radioGroup} onChange={handleDigestScope}>
                {DigestScopes.map(d => (
                  <Radio value={d.DigestScopeId} key={`${d.DigestScopeId}-digest-scope`}>
                    {d.DigestScopeDescription}
                  </Radio>
                ))}
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col>
          <Form.Item label="Please indicate your format preference">
            {form.getFieldDecorator('DigestFormatId', {
              initialValue: profile.DigestFormatId,
            })(
              <Radio.Group css={style.radioGroup}>
                {DigestFormats.map(digest => (
                  <Radio
                    css={style.radio}
                    value={digest.DigestFormatId}
                    key={`${digest.DigestFormatId}-digest-format`}
                  >
                    {digest.DigestFormatDescription}
                  </Radio>
                ))}
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

DailyDigest.propTypes = {};

export default DailyDigest;
